export const __dirname = "/";
